import axios from 'axios';
import { backendUrl } from '../constants/urls';
import clientApi from '../constants/urls';

const retrieveAllMerchant = () => {
	return clientApi.get(`${backendUrl}/merchant/auth/merchants`);
};

const MerchantService = {
	retrieveAllMerchant,
};

export default MerchantService;
